import { Design } from '@app/types';
import { useAsync } from './use-async';
import { useServices } from './use-services';
import { useSubject } from './use-subject';

export function useLocalSerializedDesigns(): Design[] | null {
  const { lokiService } = useServices();
  const [initialValue] = useAsync(() => {
    return lokiService.getSerializedDesigns();
  }, [lokiService]);
  const updatedValue = useSubject(
    lokiService.serializedDesignsChange,
    null
  );

  return updatedValue ?? initialValue;
}
